module.exports = __webpack_public_path__ + "media/dante-video.49d51168.mp4";